import axios from 'axios'

var qs = require('qs');
var root = process.env.API_ROOT

export const getPayMoneyDataNoPage = (params) => {
  return axios.post(root + '/pay/paymoney/listnopage', qs.stringify(params))
}
export const getListData = (params) => {
  return axios.post(root + '/pay/paymoney/list', qs.stringify(params))
}

//删除行
export const deleteData = (params) => {
  return axios.post(root + '/pay/paymoney/remove', qs.stringify(params))
}

//获取某一行的明细数据
export const getDetail = (params) => {
  return axios.post(root + '/pay/paymoney/detail', qs.stringify(params))
}

//保存某一行的数据
export const saveData = (params, flag) => {
  if (!flag) {//修改
    return axios.post(root + '/pay/paymoney/update', qs.stringify(params))
  } else {
    return axios.post(root + '/pay/paymoney/save', qs.stringify(params))
  }
};



// WEBPACK FOOTER //
// ./src/api/pay/paymoney.js